import React from 'react';
import { FadeIn } from './FadeIn';
import { BookOpen, Shield, MessageSquare, Zap, LifeBuoy } from 'lucide-react';
export function WhatYouGet() {
  const deliverables = [{
    icon: <BookOpen className="text-accent" size={28} data-id="element-211" />,
    title: 'La Guía Maestra "Trabajo Bajo Control"',
    desc: 'en formato PDF (lectura rápida de 30 min).'
  }, {
    icon: <Shield className="text-accent" size={28} data-id="element-212" />,
    title: 'Protocolo de la Piedra Gris',
    desc: 'Cómo neutralizar a jefes y compañeros difíciles.'
  }, {
    icon: <MessageSquare className="text-accent" size={28} data-id="element-213" />,
    title: 'Diccionario de Traducción Corporativa',
    desc: 'Scripts exactos para poner límites con elegancia.'
  }, {
    icon: <Zap className="text-accent" size={28} data-id="element-214" />,
    title: 'El Ritual del Interruptor',
    desc: 'La técnica física para no llevarte los problemas a tu casa.'
  }, {
    icon: <LifeBuoy className="text-accent" size={28} data-id="element-215" />,
    title: 'Guía de Emergencia',
    desc: 'Qué hacer cuando el estrés te desborda en plena jornada.'
  }];
  return <section className="bg-light-bg text-text-light py-20 md:py-28" data-id="element-216">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-217">
        <FadeIn data-id="element-218">
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-16 text-primary-dark" data-id="element-219">
            ¿Qué te llevás hoy?
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-220">
          {deliverables.map((item, index) => <FadeIn key={index} delay={0.1 * index} className={index === 0 ? 'md:col-span-2 lg:col-span-3' : ''} data-id="element-221">
              <div className={`bg-white p-8 rounded-xl shadow-sm border border-gray-100 h-full transition-all duration-300 hover:shadow-md hover:border-accent/30 ${index === 0 ? 'flex flex-col md:flex-row items-center md:items-start gap-6 text-center md:text-left bg-gradient-to-br from-white to-accent/5' : 'flex flex-col items-start gap-4'}`} data-id="element-222">
                <div className="bg-accent/10 p-4 rounded-full shrink-0" data-id="element-223">
                  {item.icon}
                </div>
                <div data-id="element-224">
                  <h3 className={`font-bold text-primary-dark mb-2 ${index === 0 ? 'text-2xl' : 'text-xl'}`} data-id="element-225">
                    {item.title}
                  </h3>
                  <p className="text-text-muted text-lg leading-relaxed" data-id="element-226">
                    {item.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}